import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { ConfigService } from './config.service';
import { AuthService } from './auth.service';

@Injectable()
export class InitService implements CanActivate {

  constructor(private _configService: ConfigService, private _authService: AuthService, private router: Router, private activatedRoute: ActivatedRoute) {
  }

  async canActivate(route: ActivatedRouteSnapshot) {
    await this._configService.loadConfig();
    await this._authService.Init();
    if (route.queryParams.code) {
      await this._authService.AuthorizedCallback();
      //wipes URL query string parameters from a post authentication redirect
      this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: null, queryParamsHandling: 'merge' });
      return true;
    }

    if (!this._authService.IsAuthorized) {
      await this._authService.Authorize();
      return false;
    }

    return true;
  }
}
